module.exports = __webpack_public_path__ + "static/media/optimised-web.4aba49ad.svg";